namespace $.$$ {
	
	$mol_style_define( $giper_baza_link_chip, {
		
		font: {
			family: 'monospace',
		},
		
	} )
	
}
